var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "购买记录",
        width: "1300px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
        drag: _vm.drag,
        modal: false,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "purchaseRecord" }, [
        _c(
          "div",
          [
            _c(
              "el-checkbox",
              {
                staticClass: "m-b-10",
                on: { change: _vm.searchFn },
                model: {
                  value: _vm.search.existInviteTeacher,
                  callback: function ($$v) {
                    _vm.$set(_vm.search, "existInviteTeacher", $$v)
                  },
                  expression: "search.existInviteTeacher",
                },
              },
              [_vm._v("仅查看邀约学员")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search m-b-20" },
          [
            _c("selectTelEmail", {
              staticClass: "m-r-10",
              attrs: { size: "small", width: "170px" },
              on: { onChange: _vm.searchFn },
              model: {
                value: _vm.search.userInfo,
                callback: function ($$v) {
                  _vm.$set(_vm.search, "userInfo", $$v)
                },
                expression: "search.userInfo",
              },
            }),
            _c(
              "label",
              { staticClass: "searchLabel" },
              [
                _vm._v("下单时间 "),
                _c("el-date-picker", {
                  staticClass: "m-r-10 m-l-10",
                  staticStyle: { width: "300px" },
                  attrs: {
                    size: "small",
                    type: "datetimerange",
                    format: "yyyy-MM-dd HH:mm",
                    "value-format": "yyyy-MM-dd HH:mm",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                  },
                  model: {
                    value: _vm.search.time,
                    callback: function ($$v) {
                      _vm.$set(_vm.search, "time", $$v)
                    },
                    expression: "search.time",
                  },
                }),
              ],
              1
            ),
            _c(
              "label",
              { staticClass: "searchLabel" },
              [
                _vm._v("订单状态 "),
                _c(
                  "el-select",
                  {
                    staticClass: "input-with-select select-width-200",
                    attrs: {
                      size: "small",
                      clearable: "",
                      placeholder: "请选择",
                    },
                    on: { change: _vm.searchFn, clear: _vm.searchFn },
                    model: {
                      value: _vm.search.orderStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "orderStatus", $$v)
                      },
                      expression: "search.orderStatus",
                    },
                  },
                  _vm._l(_vm.orderStatusOption, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "label",
              { staticClass: "searchLabel m-l-10" },
              [
                _vm._v("邀请人 "),
                _c(
                  "el-select",
                  {
                    staticClass: "w-200",
                    attrs: {
                      size: "small",
                      filterable: "",
                      placeholder: "请选择邀请人",
                      clearable: "",
                    },
                    on: { change: _vm.searchFn },
                    model: {
                      value: _vm.search.teacherId,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "teacherId", $$v)
                      },
                      expression: "search.teacherId",
                    },
                  },
                  _vm._l(_vm.userArray, function (item) {
                    return _c("el-option", {
                      key: item.userId,
                      attrs: { label: item.nickName, value: item.userId },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticClass: "m-l-10",
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.searchFn },
              },
              [_vm._v("查询")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "myTable" },
          [
            _c(
              "el-table",
              {
                attrs: {
                  height: "566",
                  data: _vm.list,
                  "header-cell-style": { background: "#f5f5f5" },
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "studentName",
                    label: "学员昵称",
                    width: "180",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "studentInfo" },
                            [
                              _c("AppAvatar", {
                                attrs: {
                                  name: row.studentName,
                                  avatar: row.studentAvatarUrl,
                                  width: "36",
                                  "no-name": true,
                                },
                              }),
                              _c("textShowMore", {
                                staticClass: "m-l-5",
                                staticStyle: { "max-width": "95px" },
                                attrs: {
                                  "line-clamp": 1,
                                  text: _vm.filtersTextPhone(row.studentName),
                                },
                              }),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "点击复制",
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard:copy",
                                        value: _vm.filtersTextPhone(
                                          row.studentName
                                        ),
                                        expression:
                                          "filtersTextPhone(row.studentName)",
                                        arg: "copy",
                                      },
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard:success",
                                        value: _vm.clipboardSuccess,
                                        expression: "clipboardSuccess",
                                        arg: "success",
                                      },
                                    ],
                                    staticClass:
                                      "el-icon-document-copy a_link m-l-10",
                                    staticStyle: {
                                      height: "23px",
                                      "line-height": "25px",
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "studentPhone",
                    label: "手机号码",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("watchPhoneNumber", {
                            attrs: {
                              "phone-area-code": row.phoneAreaCode,
                              "default-value": row.studentPhone,
                              params: row,
                              "user-id": row.studentId,
                              "get-api": _vm.operationLogsWrite,
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "email", label: "邮箱", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("watchPhoneNumber", {
                            attrs: {
                              "default-value": row.email,
                              params: row,
                              "user-id": row.studentId,
                              "get-api": _vm.operationLogsWriteEmail,
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "teacherName",
                    label: "邀请人",
                    "show-overflow-tooltip": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "goodsName",
                    label: "购买课程",
                    "show-overflow-tooltip": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "goodsSpec",
                    label: "商品规格",
                    "show-overflow-tooltip": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "goodsPrice",
                    label: "商品总价",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " ￥" +
                              _vm._s(
                                _vm._f("filtersMoneyByZero")(row.goodsPrice)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "payMoney",
                    label: "优惠金额",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " ￥" +
                              _vm._s(
                                _vm._f("filtersMoneyByZero")(row.discountsFee)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "payMoney",
                    label: "实付金额",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " ￥" +
                              _vm._s(
                                _vm._f("filtersMoneyByZero")(row.payMoney)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "orderNo", label: "下单单号" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "orderTime",
                    label: "下单时间",
                    align: "center",
                    width: "140",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("filterTime")(row.orderTime)) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "orderStatus",
                    label: "订单状态",
                    align: "center",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "orderStatus" },
                            [
                              row.orderStatus
                                ? _c(
                                    "MyStatus",
                                    {
                                      attrs: {
                                        status:
                                          _vm.orderStatus[row.orderStatus].type,
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.orderStatus[row.orderStatus]
                                              .name
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "payTime",
                    label: "支付时间",
                    align: "center",
                    width: "140",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("filterTime")(row.payTime)) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "paymentType", label: "支付方式" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("getOptionsValue")(
                                  row.paymentType,
                                  _vm.paymentType_options
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "transactionId", label: "流水号" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "ss-material-box-bottom",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }